import { FormattedMessage } from '@faceup/localization'
import { Form } from '@faceup/ui'
import { Button, Input } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { useMedia } from '../../mq'
import { sharedMessages } from '../../Shared/translations'

type PinInput = {
  value: string
  error: boolean
}

type CheckPinFormProps = {
  pinInput: PinInput
  setPinInput: (input: PinInput) => void
  loading: boolean
  onSubmit: () => void
  label: ReactNode
  hint: string
  errorMessage: ReactNode
}

const CheckPinForm = ({
  pinInput,
  setPinInput,
  loading,
  onSubmit,
  label,
  hint,
  errorMessage,
}: CheckPinFormProps) => {
  const isLgDown = useMedia('lgDown')

  return (
    <Form onSubmit={onSubmit}>
      <Form.Item withAsterisk label={label} hint={hint} {...(pinInput.error && { errorMessage })}>
        <Input
          autoComplete='off'
          data-test='check-report-input'
          size='large'
          value={pinInput.value}
          maxLength={50}
          onChange={({ target: { value } }) => {
            setPinInput({
              value:
                // do not format input while deleting spaces (Backspace)
                pinInput.value.endsWith(' ') && pinInput.value.trim() === value
                  ? value
                  : value
                      .split(' ')
                      .join('')
                      .replace(/(.{4})/g, '$1 '),
              error: false,
            })
          }}
        />
      </Form.Item>
      <Form.Item>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            data-test='check-report-button'
            type='primary'
            block={isLgDown}
            htmlType='submit'
            loading={loading}
          >
            <FormattedMessage message={sharedMessages.continue} />
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}

export default CheckPinForm
